<template>
    <div class="container">
        <v-card>
            <v-card-title class="titulopagina">PRODUCCION DE ACEITE</v-card-title>            
            <v-card-text class="pb-0">
                <v-row>
                    <v-col cols="3" sm="3">
                        <p>Seleccione Fecha de Producción</p>
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarDespachos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="1" sm="1">
                    </v-col>
                    <v-col cols="2" sm="2">
                        <v-text-field v-model="produccion_dia" label="Producción diaria" placeholder="Producción diaria"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6">
                        <tr v-for="pm in prod_maxis" :key="pm.id" >
                            <td class="pr-2 pl-2" :class="pm.barrido == 1 ? 'filaimpar' : ''" > {{pm.linea}} </td> | 
                            <td class="pr-2 pl-2" :class="pm.barrido == 1 ? 'filaimpar' : ''" > {{pm.materia_prima}} </td> | 
                            <td class="pr-2 pl-2"> {{pm.cant_jumbos}} maxis </td> | 
                            <td class="pl-2"> {{pm.total_kilos | formatear_miles}} kgs</td>
                            <td v-if="pm.barrido == 1"> BARRIDO</td>
                        </tr>                        
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!--tabla nueva produccion-->
        <v-card class="mt-2">
                <v-col class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                    Producción Guardada Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-col>
            <v-simple-table dense fixed-header height="550px">
                <thead>
                    <tr>
                        <th class="cabecera">Estanque</th>
                        <th class="cabecera">Stock Inicial</th>
                        <th class="cabecera">Materia Prima</th>
                        <th class="cabecera">Despacho</th>
                        <th class="cabecera">Linea</th>
                        <th class="cabecera">Producción</th>
                        <th class="cabecera">Stock Final</th>
                        <th class="cabecera">Observación</th>
                        <th class="cabecera">Folio Producción</th>
                        <th class="cabecera">Agregar Fila</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in lista_resumen" :key="item.id">
                        <td class="text-center">{{item.estanque}}
                            <span class="lime"><small>{{item.estanque_tag}} </small></span>
                        </td>
                        <td class="text-right">{{item.stock_inicial | formatear_miles}}</td>
                        <td class="text-center">
                            <v-select
                                v-model="item.tipo_mps_id"
                                :items="tipo_mps"
                                item-text="tipo_materia_prima"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                                @change="saveProduccion(item)"
                            ></v-select>
                        </td>
                        <td class="text-center">{{item.despacho_aceite | formatear_miles}}</td>
                        <td class="text-center">
                            <v-select
                                v-model="item.lineas_id"
                                :items="lineas"
                                item-text="nombre_linea"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                                @change="saveProduccion(item)"
                            >
                            </v-select>
                        </td>
                        <td class="text-center">
                            <v-text-field v-model="item.produccion" @change="saveProduccion(item)" type="number" reverse dense></v-text-field>
                        </td>
                        <td class="text-right">
                            <v-text-field v-model="item.stock_final" type="text" reverse readonly dense></v-text-field>
                        </td>
                        <td class="text-left">
                            <v-text-field v-model="item.observacion_aceite" type="text" @change="saveProduccion(item)" dense></v-text-field>
                        </td>
                        <td class="text-center">
                            <!--<v-switch v-model="item.revisado" @change="saveProduccion(item)" dense></v-switch>-->
                            <v-text-field v-model="item.folio_produccion" type="text" @change="saveProduccion(item)" dense></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-btn @click="agregarFila(item,index)" small icon dark color="green darken 1"><v-icon>add_circle</v-icon></v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-card>
        <!--tabla nueva produccion-->
        <v-row>
            <v-col cols="5">
                <h3 class="pa-4">Produccion de Aceite por fechas {{this.rango_fechas[0] | formatearFecha}} - {{this.rango_fechas[1] | formatearFecha}}</h3>
            </v-col>
            <v-col cols="3">
                <date-picker class="ml-2" v-model="rango_fechas" @change="cargarProduccionEstanques(true)" placeholder="Rango de Fechas a Mostrar" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="10">
                <!-- detalle produccion -->
                <v-card>
                    <v-simple-table
                        fixed-header
                        width="100%"
                        height="90vh"
                    >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="cabecera text-center" colspan="6">PRODUCCION</th>
                                <th class="text-center blue darken-2 borde-left" colspan="4">DESPACHOS</th>
                            </tr>
                            <tr>
                                <th class="cabecera">Fecha</th>
                                <th class="cabecera">Tipo MMPP</th>
                                <th class="cabecera">L</th>
                                <th class="cabecera">Estanque</th>
                                <th class="cabecera">Litros</th>
                                <th class="cabecera">X</th>

                                <th class="text-center blue darken-2 borde-left">Fecha</th>
                                <th class="text-center blue darken-2 ">Litros</th>
                                <th class="text-center blue darken-2">Guía</th>
                                <th class="cabecera">X</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,idx) in lista_prod" :key="idx" :class="item.color">
                                <td class="text-center borde-left">{{item.fecha | formatearFecha}}</td>
                                <td class="text-left borde-left">{{item.mmpp}}</td>
                                <td class="text-center borde-left">{{item.linea}}</td>
                                <td class="text-center borde-left">{{item.estanque}}</td>
                                <td class="text-right borde-left">{{item.produccion | formatear_miles}}</td>
                                <td>
                                    <v-btn color="red darken-4" dark small icon @click="eliminar_prod(item, idx)" title="Eliminar Producción">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </td>
                                <td class="text-right borde-left" colspan="4">
                                    <tr v-for="(it,id) in item.despachos" :key="id"  width="100% !important"> 
                                        <td class="text-center" width="45% !important">{{it.fecha_d | formatearFecha}}</td>
                                        <td class="text-right borde-left" width="45% !important">{{it.cantidad | formatear_miles}}</td>
                                        <td class="text-right borde-left" width="45% !important">{{it.guia}}</td>
                                        <td>
                                            <v-btn color="red darken-4" dark small icon @click="eliminar_desp(it, idx, id)" title="Eliminar Producción">
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    </v-simple-table>
                </v-card>
            </v-col>

            <v-col cols="2">
                <v-card>
                    <v-simple-table
                        fixed-header
                        width="100%"
                        height="90vh"
                    >
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="cabecera text-center" colspan="5">STOCKS</th>
                            </tr>
                            <tr>
                                <th class="cabecera">Estanque</th>
                                <th class="cabecera">Litros</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,idx) in stocks_tks" :key="idx" :class="item.color">
                                <td class="text-center borde-left">{{item.estanque}}</td>
                                <td class="text-right borde-left">{{item.kilos | formatear_miles}}</td>
                            </tr>
                        </tbody>
                    </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-row>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import Loader_Lineal_Configurable from '@/components/shared/Loader_Lineal_Configurable.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
import Loader_Lineal from '@/components/shared/Loader_Lineal.vue';
export default {
    data:()=>({
        despacho: {},
        despachos: [],
        prod_maxis:[],
        rango_fechas:'',
        produccion_dia: 0,
        turno: null,
        stocks_tks: [],
        lista_prod: [],
        lista_resumen: [],
        lista_romana: [],
        lista_estanques: [],
        estanques:[],
        estanques_despacho:[],
        estanques_produccion:[],
        turnos: [],
        lineas:[],
        tipo_mps: [],
        tipo_produccion_id:2,
        sello:0,
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        dialog: false,
        alert:false,
        despacho_romana: [],
        prodclass: '',
        binclass: '',
        progreso_despacho:false,
        //configuracion para datatable
        cabeceras_estanques:[
            {
                text: 'Estanque',
                align: 'center',
                sortable: true,
                value: 'codigo',
                class: 'light-blue darken-3 titulo2',
                // value: 'estanque',
            },
            {
                text: 'Despacho',
                align: 'center',
                sortable: true,
                value: 'litros',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Acidez',
                align: 'center',
                sortable: true,
                value: 'acidez_aceite',
                class: 'light-blue darken-3 titulo2',
            },
        ],
        //configuracion para datatable
        cabeceras_romana:[
            {
                text: 'Fecha Salida',
                align: 'center',
                sortable: true,
                value: 'fecha_hora_ticket',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Patente',
                align: 'center',
                sortable: true,
                value: 'patente',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Destino',
                align: 'center',
                sortable: true,
                value: 'sucursal',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Guia',
                align: 'center',
                sortable: true,
                value: 'numero_guia',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Url guía',
                align: 'center',
                sortable: true,
                value: 'url_guia',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Cantidad',
                align: 'center',
                sortable: true,
                value: 'peso_real',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Por Asignar',
                align: 'center',
                sortable: true,
                value: 'pendiente',
                class: 'light-blue darken-3 titulo2',
            },
            {
                text: 'Total Asignado',
                align: 'center',
                sortable: true,
                value: 'distribuido',
                class: 'light-blue darken-3 titulo2',
            },
            {
                // text: 'Estanque',
                text: 'Asignar',
                align: 'center',
                sortable: true,
                value: 'class',
                class: 'light-blue darken-3 titulo2',
            }
        ],
        acciones:[]
    }),
    mounted() {
        this.cargarTurnos();
        this.cargarLineas();
        this.cargarTipoMps();
        this.cargarEstanques();
        this.cargarProduccionEstanques(false);

    },
    methods: {
        closeDialog(){
            if(this.litros_restantes_despacho > 0){
                console.log('Falta distribuir')
                this.dialog = true;
                return
            }
            this.dialog = false;
        },
        async saveProdDiaria(){
            let url = `${this.base_url}produccion_aceite/prod_diaria`;
            let data = {
                fecha: this.fecha,
                produccion_dia: this.produccion_dia
            }
            await this.axios.post(url, data, this.headers).then((response)=>{
                console.log(response.data)
            }).catch((error)=>{
                console.log(error);
            });
        },
        async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.turnos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarLineas(){
            let url = `${this.base_url}lineas`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.lineas = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarMaxis(){
            if (this.fecha) {
                let url = `${this.base_url}produccion_maxis/${this.fecha}`;
                await this.axios.get(url,this.headers).then((response)=>{
                    this.prod_maxis = response.data.data;
                }).catch((error)=>{
                    console.log(error);
                    this.ocultarLoading();
                });
            } else {
                this.prod_maxis = []
            }
            
        },
        agregarFila(item,index){
            let nuevo = {
                despacho_aceite: item.despacho_aceite,
                estanque: item.estanque,
                estanque_tag: item.estanque_tag,
                estanque_aceites_id: item.estanque_aceites_id,
                fecha: item.fecha,
                id: null,
                lineas_id: null,
                produccion: null,
                produccion_turno_id: item.produccion_turno_id,
                observacion_aceite: null,
                folio_produccion: null,
                revisado: 0,
                stock_estanque: item.stock_estanque,
                tipo_mps_id: null,
                turnos_id: item.turnos_id
            }
            Array.prototype.insert = function ( index, item ) {
                this.splice( index+1, 0, item );
            };
            this.lista_resumen.insert(index, nuevo);
        },
        async cargarTipoMps(){
            let url = `${this.base_url}tipo_produccion/2/tipo_mps`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.tipo_mps = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachos(){
            this.cargarDespachoAceite();
            this.cargarDespachosRomana();
            this.cargarDespachosAceite();
            this.cargarProduccionTurno();
            this.cargarMaxis();
        },
        async cargarDespachoAceite(){
            let manana = this.moment(this.fecha).add(1, 'days').format('YYYY-MM-DD');
            let ayer = this.moment(this.fecha).subtract(1, 'days').format('YYYY-MM-DD');
            let url = `${this.base_url}despacho_aceite/por_fecha/${ayer}/${manana}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.despachos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachosAceite(){
            let url = `${this.base_url}produccion_aceite/despachos/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_estanques = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachosRomana(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            this.alert = false;
            let url = `${this.base_url}produccion_aceite/despachos_romana/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_romana = response.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarProduccionTurno(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            //let url = `${this.base_url}produccion_aceite/produccion/${this.turno.id}/${this.fecha}`;
            let url = `${this.base_url}produccion_aceite/produccion/0/${this.fecha}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_resumen = response.data.data;
                Event.$emit('inicializar_tabla', this.cabeceras, this.lista, this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
            this.produccion_dia_suma();
        },
        async cargarProduccionEstanques(token){
            let data = { hola: ''}
            if (token == true) {
                data = {    fecha_ini:this.rango_fechas[0],
                            fecha_fin:this.rango_fechas[1]}
            }
            let url = `${this.base_url}produccion_aceite/produccion_estanques`;
            await this.axios.post(url, data, this.headers).then((response)=>{
                this.lista_prod = response.data.data;
                this.stocks_tks = response.data.stocks;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },


        guardarSello(){
            this.lista_estanques.forEach(estanque => {
                this.$set(estanque, 'sellos', this.despacho != undefined ? this.despacho.sello : 0);
            });
        },
        async saveDespacho(item){
            this.progreso_despacho = true;
            item.patente = this.despacho_romana.patente.trim();
            item.despacho_romana_id = this.despacho_romana.tickets_id;
            item.guia = this.despacho_romana.numero_guia;
            /*if(!this.despacho.sello){
                console.log("no se ha digitado sellos");
                return;
            }*/
            let data = {
                fecha: this.fecha,
                tipo_produccion_id: this.tipo_produccion_id,
                despacho_romana_id: item.despacho_romana_id,
                guia: item.guia,
                estanque_aceites_id: item.id,
                patente: item.patente,
                kilos: item.kilos,
                acidez_aceite: item.acidez_aceite,
                turnos_id: 0
            };
            if(item.despacho_pt_id > 0){
                // update
                let url = `${this.base_url}despacho_pt/${item.despacho_pt_id}`;
                await this.axios.put(url, data, this.headers).then((response) => {
                    let stock = response.data.data;
                    item.despacho_pt_id = stock.id;
                    console.log(this.despacho_romana);
                    this.actualizarProduccion(response.data.data.estanque_aceites_id);
                    this.actualizarDespachoRomana(this.despacho_romana.tickets_id, this.despacho_romana.numero_guia);
                    this.progreso_despacho = false;
                }).catch((error)=>{
                    console.log(error);
                    this.progreso_despacho = false;
                });
            }else if (item.despacho_pt_id == 0){
                // store new
                let url = `${this.base_url}despacho_pt`;
                await this.axios.post(url, data, this.headers).then((response) => {
                    let despacho = response.data.data;
                    item.despacho_pt_id = despacho.id;
                    this.actualizarProduccion(response.data.data.estanque_aceites_id);
                    this.actualizarDespachoRomana(this.despacho_romana.tickets_id, this.despacho_romana.numero_guia);
                    this.progreso_despacho = false;
                }).catch((error)=>{
                    console.log(error);
                    this.progreso_despacho = false;
                });
            }
            this.cargarDespachos();
        },
        async actualizarDespachoRomana(ticket,guia){
            let url = `${this.base_url}despachos_romana/${ticket}/${guia}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.despacho_romana = res.data.data;
                /**conocer la posicion (index) por medio de propiedad de un objeto */
                let pos = this.lista_romana.map(function(e) { return e.id; }).indexOf(ticket);
                console.log("despacho_romana", this.despacho_romana);
                this.lista_romana.forEach(d => {
                    console.log("lista", d);
                    if((ticket == d.tickets_id) && (guia == d.numero_guia)){
                        this.$set(e,'despacho_pt_id',d.id);
                        this.$set(e,'kilos',d.kilos);
                        this.$set(e,'acidez_aceite',d.acidez_aceite);
                        this.$set(e,'bins',d.bins);
                        this.$set(e,'sellos',d.sellos);
                    }
                });

                this.$set(this.lista_romana, pos, res.data.data);

            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async saveProduccion(item){
            let data = {
                fecha: this.fecha,
                //turnos_id: this.turno.id,
                turnos_id: 0,
                // tipo_produccion_mps_id: item.tipo_produccion_mps_id.id,
                tipo_mps_id: item.tipo_mps_id,
                lineas_id:item.lineas_id,
                estanque_aceites_id: item.estanque_aceites_id,
                tipo_produccion_id:2,
                produccion: item.produccion,
                observacion_aceite: item.observacion_aceite,
                folio_produccion: item.folio_produccion,
                //bins: item.bins,
                revisado: 0 // item.revisado
            };
            this.produccion_dia_suma();
            this.alert = false;
            if((data.tipo_mps_id > 0) && (data.lineas_id > 0) && (data.estanque_aceites_id > 0) && (data.fecha != null)){
                console.log('actualizando',item);

                if(item.id > 0){
                    // update
                    let url = `${this.base_url}produccion_aceite/${item.produccion_turno_id}`;
                    await this.axios.put(url, data, this.headers).then((response) => {
                        let prod = response.data.data;
                        item.produccion_turno_id = prod.id;
                        this.actualizarResumen(response.data.data);
                        this.alert = true;
                    }).catch((error)=>{
                        console.log(error);
                    });
                }else if (item.id == null){
                    // store new
                    let url = `${this.base_url}produccion_aceite`;
                    await this.axios.post(url, data, this.headers).then((response) => {
                        let prod = response.data.data;
                        item.id = prod.id;
                        item.produccion_turno_id = prod.id;
                        this.actualizarResumen(response.data.data);
                        this.alert = true;
                    }).catch((error)=>{
                        console.log(error);
                    });
                }
            }
        },
        goto(link){
            let url_actual = window.location.href
            if(url_actual.includes('190.13.184.67') || url_actual.includes('localhost')){
                window.open("https://190.13.184.67:444/romana2/backend/public/guias/"+link);
            }else if(url_actual.includes('192.168.205.150')){
                window.open("https://192.168.205.150/romana2/backend/public/guias/"+link);
            }
        },
        copia_info(it,litros){
            this.estanques_despacho.forEach(e => {
                if (it.estanque_aceites_id == e.id){
                    this.$set(e,'acidez_aceite',it.acidez);
                    this.$set(e,'litros',litros);
                    this.saveDespacho(e);
                    console.log(e);
                }
            });

        },
        async showModal(item){
            this.despacho_romana = item;
            this.despacho = this.despachos.filter(d => {
                let manana = this.moment(this.fecha).add(1, 'days').format('YYYY-MM-DD');
                let ayer = this.moment(this.fecha).subtract(1, 'days').format('YYYY-MM-DD');
                console.log (ayer,manana,d.fecha, d.guia, item.numero_guia);
                return ((d.fecha >= ayer) && (d.fecha <= manana) && (d.guia == item.numero_guia));
            })
            if(this.despacho == undefined) this.despacho = {};
            console.log(this.despacho);
            await this.cargarDistribucionEstanques(this.despacho_romana.tickets_id,this.despacho_romana.numero_guia);
            this.dialog = true;
        },
        async cargarDistribucionEstanques(ticket,guia){
            await this.limpiarEstanquesDespacho(this.estanques_despacho);
            let url = `${this.base_url}despacho_pts/despacho_id/${ticket}/${guia}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                await this.setearEstanquesDespacho(res.data.data);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques = res.data.data;
                this.estanques_despacho = res.data.data;
                await this.limpiarEstanquesDespacho(this.estanques_despacho);
                this.estanques_produccion = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async limpiarEstanquesDespacho(estanques){
            await estanques.forEach(e => {
                this.$set(e,'despacho_pt_id',0);
                this.$set(e,'kilos',0);
                this.$set(e,'acidez_aceite', this.despacho != undefined ? this.despacho.acidez : 0);
                this.$set(e,'bins',0);
                this.$set(e,'sellos',0);
            });
        },
        async setearEstanquesDespacho(despachos_pt){
            await this.estanques_despacho.forEach(e => {
                despachos_pt.forEach(d => {
                    if(e.id == d.estanque_aceites_id){
                        this.$set(e,'despacho_pt_id',d.id);
                        this.$set(e,'kilos',d.kilos);
                        this.$set(e,'acidez_aceite',d.acidez_aceite);
                        this.$set(e,'bins',d.bins);
                        this.$set(e,'sellos',d.sellos);
                    }
                });
            });
        },
        async actualizarProduccion(estanque_id){
            let item_produccion = this.lista_resumen.find(prod => prod.estanque_aceites_id == estanque_id);
            let url = ``;
            if(item_produccion.produccion_turno_id > 0){
                url = `${this.base_url}produccion_turno/${item_produccion.produccion_turno_id}`;
            }else{
                url = `${this.base_url}produccion_turno/${estanque_id}/0/${this.fecha}`;
            }
            await this.axios.get(url,this.headers).then((response)=>{
                this.actualizarResumen(response.data.data);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async actualizarResumen(item){
            this.lista_resumen.forEach(async row => {
                if (row.estanque_aceites_id == item.estanque_aceites_id){
                    console.log(item)
                    row.despacho_aceite = item.despacho_aceite;
                    row.stock_final = row.stock_inicial - item.despacho_aceite;
                }
            });
        },
        async obtenerTotalDespachoEstanque(estanque_id,fecha,turno_id){
            let total_litros = 0;
            let url = `${this.base_url}despacho_pts/${estanque_id}/${fecha}/${turno_id}`;
            await this.axios.get(url,this.headers).then((res)=>{
                total_litros = res.data.total_litros;
            }).catch((error)=>{
                console.log('error',error);
            });
            return total_litros;
        },
        checkDistribucion(){
            if(litros_restantes_despacho != 0){
                console.log('No se ha distribuido correctamente');
            }
        },
        produccion_dia_suma(){
            let prod = 0;
            this.lista_resumen.forEach(e => {
                if (e.produccion && !isNaN(parseInt(e.produccion))){
                    prod += parseInt(e.produccion);
                }
            });
            console.log(prod);
            this.produccion_dia = prod;
        },
        async eliminar_prod(item, idx){
            console.log(item);
            if(item.despachos.length == 0) {
                const okei = await this.$refs.confirmDialogue.show({
                    title: 'Confirmar eliminación',
                    message: `Desea eliminar producción fecha ${item.fecha} del listado ?`,
                    okButton: 'Eliminar !!',
                })
                if(okei) {
                    let le_pt = {  _method: "DELETE"  }
                    await this.axios.post(`${this.base_url}produccion_turno/${item.pts_id}`,le_pt,this.headers).then((res)=>{
                        this.lista_prod.splice(idx,1);
                        console.log(res);
                    }).catch((e)=>{
                        this.errorMessage(e, "Error al eliminar producción.");
                    })
                }
            } else {
                const okei = await this.$refs.confirmDialogue.show({
                    title: 'No se Puede Eliminar',
                    message: `Producción ya tiene despachos. Debería eliminar primero los despachos`,
                    okButton: 'OK !!',
                })
                if(okei) {
                    
                }
            }
        },
        async eliminar_desp(item, idx, id){
            console.log(item);
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar despacho fecha ${item.fecha_d} del listado ?`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                let el_id = { id: item.id }
                await this.axios.post(`${this.base_url}despacho_aceite/destroy_desp_romana_prod`, el_id, this.headers).then((res)=>{
                    delete this.lista_prod[idx].despachos[id];
                    this.$set(this.lista_prod[idx], "despachos", { ...this.lista_prod[idx].despachos });
                    console.log("lista_prod", this.lista_prod[idx]);

                }).catch((e)=>{
                    const oka = this.$refs.confirmDialogue.show({
                        title: 'No se Puede Eliminar',
                        message: `Despacho ya tiene recepciones, no se puede eliminar`,
                        okButton: 'OK !!',
                    })
                    if(oka) {
                        
                    }
                    console.log(e);
                })
            }
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'roles']),
        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        },
        litros_restantes_despacho(){
            let litros = 0;
            if(this.despacho_romana){
                litros = this.despacho_romana.peso_real;
                this.estanques_despacho.forEach(e => {
                    litros -= e.litros;
                });
            }
            return litros;
        },
        
    },
    components:{
        'modal':Modal,
        ConfirmDialogue,
        'data-table':Data_Table,
        'loader-configurable':Loader_Lineal_Configurable,
        DatePicker
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
    .alert{
        color: red;
    }
    .titulo2{color: white !important; font-size: 1em !important; }
    th {color: white !important; font-size: 0.9em !important; }
    .borde-left{border-left: 1px solid white !important;}
    .filapar{
        background-color: #80DEEA;
    }
    .filaimpar{
        background-color:#80CBC4;
    }
    .mx-datepicker{width: 100%!important;}
</style>